import { FormComponentType } from "@components/FormBuilder/types"
import { GenericForm } from "@custom-types/form"
import { DropdownOptions } from "@custom-types/common"

type getAddProductFormFieldsProps = {
  organisationOptions: DropdownOptions
  divisionOptions: DropdownOptions
}

export const getAddProductFormFields = ({
  organisationOptions = [],
  divisionOptions = [],
}: getAddProductFormFieldsProps): GenericForm => ({
  name: {
    title: "Name",
    editable: true,
    type: FormComponentType.NameInput,
  },
  description: {
    title: "Description",
    editable: true,
    type: FormComponentType.Textarea,
  },
  organisation_key: {
    title: "Organisation",
    editable: true,
    type: FormComponentType.Dropdown,
    options: organisationOptions,
  },
  division_key: {
    title: "Division",
    editable: true,
    type: FormComponentType.Dropdown,
    options: divisionOptions,
  },
  active: {
    title: "Active",
    editable: true,
    type: FormComponentType.Checkbox,
  },
  is_external: {
    title: "Is External",
    editable: true,
    type: FormComponentType.Checkbox,
  },
})
